import React, { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";
import './scrollToTop.css';

export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 200) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
    
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    return (
        <>
            {isVisible && (
                <button
                onClick={scrollToTop}
                className="scroll-top"
                aria-label="Volver arriba"
                >
                    <ArrowUp size={45} />
                </button>
                )}
        </>
    );

}
